import React, { useState, useRef, useEffect, useMemo, useCallback } from 'react';
import Modal from '@components/common/Modal';
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
import { Formik, Form } from 'formik';
import KeyboardInput from '@components/common/formElements/KeyboardInput/keyboardInput';
import { isEmpty } from 'lodash';
import cn from 'classnames';
import style from './checksCommon.module.scss';
import {
  getObjectValue,
  deconstructStringUrl,
  urlSearchParams,
} from '@utility/utills';
import CheckBox from '@components/common/formElements/CheckBoxFormik';
import Loader from '@components/common/Loader/newLoaderModal';
import { flowType } from '../../utility/userInfo';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { keyboardCloseForDone,keyboardOpen, keyboardOpenForClickText } from '@reducers/keyboard';
import CustomKeyboard from '@components/common/CustomKeyboardCopy/indexRevamp';
import { TouchableButton } from '@components/common/Touchable';
import { setErrorPopUp } from '@reducers/notification';
import { handleLoyaltyInfo } from "@reducers/loyalty";

const ReceiptScreenPopUp = props => {
  const [isLink, setIsLink] = useState({ isOpen: false, link: '' });
  const [loader, setLoader] = useState(false);
  const [disclamer, setDisclamer] = useState('');
  const iframeRef = useRef(null);
  const screenType = useMemo(() => urlSearchParams('screenType').trim(), []);
  const {
    type,
    handleReceipt,
    isOpen,
    onClose,
    countryCode,
    phoneNumberMaxLength,
    handleCountryCodeChange,
    SingedInloyaltyInfo,
    paymentType
  } = props;
  const storeInfo = useMemo(
    () =>
      getObjectValue(
        () => JSON.parse(window.sessionStorage.getItem('auth')),
        {}
      ),
    []
  );
  const loyaltyData = useMemo(
    () =>
      getObjectValue(
        () =>
          JSON.parse(window.sessionStorage.getItem('loyaltyData')) ||
          JSON.parse(window.sessionStorage.getItem('giftCardReceiptData')),
        ''
      ),
    []
  );
  const paymentCheck = useMemo(
    () =>
      getObjectValue(
        () =>
          JSON.parse(window.sessionStorage.getItem('paymentCheck'))
      ),
    []
  );

  const counterPhoneNumber =
    getObjectValue(
      () => window.sessionStorage.getItem('counterPhoneNumber'),
      ''
    ) ||
    (SingedInloyaltyInfo?.type === 'PhoneNumber' &&
      SingedInloyaltyInfo?.phoneNumber);

  const [linkList, setLinkList] = useState([]);
  const timeoutId = useRef(null);
  const isServerApp = flowType() === 'serverApp';
  const isLandScape = true;
  storeInfo.loyaltyInfo.optInMethods.includes(type) &&
    (type === 'phone'
      ? storeInfo.loyaltyInfo.smsOptInDisclaimer
      : storeInfo.loyaltyInfo.emailOptInDisclaimer) &&
    storeInfo.loyaltyInfo.supportsOptIn;
  const [zipcodeKeyOpen, setZipcodeKeyOpen] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const inputValueRef = useRef(inputValue);
  inputValueRef.current = inputValue;
  const valuesRef = useRef({});
  const [optInData, setOptInData] = useState(false);
  const code = countryCode?.toString() || '1';
  const stationName =
    props.seat?.stationName?.length > 8
      ? props.seat?.stationName?.substring(0, 8).concat('...')
      : props.seat.stationName || props.seat.stationNumber;

  const hasZipcode = storeInfo?.loyaltyInfo?.smsOptInFields?.includes(
    'zipcode'
  );
  const hasEmailZipcode = storeInfo?.loyaltyInfo?.emailOptInFields?.includes(
    'zipcode'
  );
  const hasDisclaimer = storeInfo?.loyaltyInfo?.supportsOptIn;
  const hasPhone = storeInfo.loyaltyInfo.optInMethods?.includes('phone');
  const hasEmail = storeInfo.loyaltyInfo.optInMethods?.includes('email');
  const hasSmsOptinDsclaimer = storeInfo.loyaltyInfo.smsOptInDisclaimer;
  const isOnlyPhone = hasPhone && !hasZipcode && !hasDisclaimer;
  const isOnlyEmail =
    type === 'email' && hasEmail && !hasEmailZipcode && !hasDisclaimer;

  let keyboardBottomClass = '';
  if (hasZipcode && hasPhone && hasDisclaimer) {
    keyboardBottomClass = style.receiptKeyboardStyle;
  } else if (hasZipcode && hasPhone) {
    keyboardBottomClass = style.receiptKeyboardStyle2;
  }

  useEffect(() => {
    const disclamers =
      type === 'phone'
        ? storeInfo.loyaltyInfo.smsOptInDisclaimer || ''
        : storeInfo.loyaltyInfo.emailOptInDisclaimer || '';
    if (disclamers?.length > 0) {
      const [link, concatChar] = deconstructStringUrl(disclamers);
      setLinkList(link);
      setDisclamer(concatChar.split('¿'));
    }
  }, [type]);

  const validateEmail = value => {
    const error = {};

    if (!value.email) {
      props.setErrorPopUp({
        res: CUSTOM_MESSAGES().OLS_EMAIL_FIELD_REQUIRED,
        noErrorTxt: true,
      });
      error.email = 'required';
    } else if (
      !value.email.match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
    ) {
      props.setErrorPopUp({
        res: CUSTOM_MESSAGES().OLS_EMAIL_INVALID,
        noErrorTxt: true,
      });
      error.email = 'invalid';
    } else if (storeInfo.loyaltyInfo.optInDisclaimer && !value.optIn) {
      props.setErrorPopUp({
        res: CUSTOM_MESSAGES().OLS_NUMBER_DEGIT_ERROR,
        noErrorTxt: true,
      });
      error.optIn = 'not_agreed';
    }

    return error;
  };

  const maxLength = code === '1' ? 10 : phoneNumberMaxLength;

  const validatePhone = value => {
    const error = {};
    const phone = !isEmpty(value.phone) ? value.phone.replace('-', '') : '';

    if (isEmpty(value.phone)) {
      props.setErrorPopUp({
        res: CUSTOM_MESSAGES().OLS_NUMBER_FIELD_REQUIRED,
        noErrorTxt: true,
      });
      error.phone = 'Enter a phone number';
    } else if (Number(code) === 1 && phone.length < maxLength) {
      props.setErrorPopUp({
        res: CUSTOM_MESSAGES().OLS_NUMBER_DEGIT_ERROR,
        noErrorTxt: true,
      });
      error.phone = `Phone number should have ${maxLength} digits`;
    } else if (storeInfo.loyaltyInfo.optInDisclaimer && !value.optIn) {
      props.setErrorPopUp({
        res: CUSTOM_MESSAGES().OLS_PLEASE_AGREE_TERMS,
        noErrorTxt: true,
      });
      error.phone = 'Please agree to the terms and conditions';
    }

    return error;
  };

  const handleLink = text => {
    const index = linkList.findIndex(d => d === text);
    const link = linkList[index + 1];
    setIsLink({ isOpen: true, link });
    setLoader(true);
    timeoutId.current = setTimeout(() => {
      clearTimeout(timeoutId.current);
      setLoader(false);
    }, 30 * 1000);
  };

  const handleBlur = () => {
    props?.keyboardCloseForDone();
    document.querySelector('#zipcode').blur();
  };

  const closeKeyboard = useCallback(() => {
    setZipcodeKeyOpen(false);
  }, []);

  const memoizedKeyboardOnClick = useCallback((e) => {
    const current = inputValueRef.current;
    if (current.length !== 5) {
      setInputValue(e === '{bksp}' ? current.slice(0, -1) : current.concat(e));
    }
    if (e === '{bksp}') {
      setInputValue(current.slice(0, -1));
    }
    if (!valuesRef.current.optIn) {
      setInputValue('');
    }
  }, []);

  const handleReceiptSubmit = data => {
    if (paymentType === 22) {
      if (
        type === 'email' &&
        storeInfo?.loyaltyInfo?.emailOptInFields?.length > 0 &&
        storeInfo?.loyaltyInfo?.emailOptInFields?.some(
          field => field?.toLowerCase() === 'zipcode'.toLowerCase()
        )
      ) {
        if (data.optIn && inputValue?.length !== 5) {
          props.setErrorPopUp({
            res: 'ZIP code should have 5 digits',
            noErrorTxt: true,
          });
        } else {
          handleReceipt({
            ...data,
            optIn:
              storeInfo.loyaltyInfo?.optInMethods?.length > 0 &&
              storeInfo.loyaltyInfo?.optInMethods?.includes(type) &&
              data?.optIn,
            accountNumber: loyaltyData?.accountNumber || null,
            ZipCode: inputValue,
          });
          setZipcodeKeyOpen(false);
          setInputValue('');
        }
      } else if (
        type === 'phone' &&
        storeInfo?.loyaltyInfo?.smsOptInFields?.length > 0 &&
        storeInfo?.loyaltyInfo?.smsOptInFields?.some(
          field => field?.toLowerCase() === 'zipcode'.toLowerCase()
        )
      ) {
        if (data.optIn && inputValue?.length !== 5) {
          props.setErrorPopUp({
            res: 'ZIP code should have 5 digits',
            noErrorTxt: true,
          });
        } else {
          handleReceipt({
            ...data,
            optIn:
              storeInfo.loyaltyInfo?.optInMethods?.length > 0 &&
              storeInfo.loyaltyInfo?.optInMethods?.includes(type) &&
              data?.optIn,
            accountNumber: loyaltyData?.accountNumber || null,
            ZipCode: inputValue,
          });
          setZipcodeKeyOpen(false);
          setInputValue('');
        }
      } else {
        const str = data?.phone;
        const numbersOnly = str?.replace(/\D/g, ""); // Removes all non-digit characters

        const updatedData = {
          phoneNumber: numbersOnly,
          email: null,
          type: "PhoneNumber",
        };

        props?.handleLoyaltyInfo(updatedData);
        handleReceipt({
          ...data,
          optIn:
            storeInfo?.loyaltyInfo?.optInMethods?.length > 0 &&
            storeInfo?.loyaltyInfo?.optInMethods?.includes(type) &&
            data?.optIn,
          accountNumber: loyaltyData?.accountNumber || null,
        });
      }
    } else {
      const str = data?.phone;
      const numbersOnly = str?.replace(/\D/g, ""); // Removes all non-digit characters

      const updatedData = {
        phoneNumber: numbersOnly,
        email: null,
        type: "PhoneNumber",
      };

      props?.handleLoyaltyInfo(updatedData);
      handleReceipt({
        ...data,
        optIn:
          storeInfo?.loyaltyInfo?.optInMethods?.length > 0 &&
          storeInfo?.loyaltyInfo?.optInMethods?.includes(type) &&
          data?.optIn,
        accountNumber: loyaltyData?.accountNumber || null,
      });
    }
  };

  const handleCloseReceipt = () => {
    setZipcodeKeyOpen(false);
    setInputValue('');
    onClose();
  };

  const processTruncatedDisclaimer = () => {
    const needsTruncation =
      (screenType === '22' || screenType === '27') && disclamer?.length > 0;

    if (!needsTruncation) return disclamer;

    const fullText = disclamer
      .map(text => (text.startsWith('#?') ? text.replace('#?', '') : text))
      .join(' ');

    const MAX_CHARS = 80;

    if (fullText.length > MAX_CHARS) {
      const truncatedText = fullText.substring(0, MAX_CHARS);
      const lastSpaceIndex = truncatedText.lastIndexOf(' ');
      const finalText =
        lastSpaceIndex > 0
          ? truncatedText.substring(0, lastSpaceIndex)
          : truncatedText;
      return [finalText];
    }

    return disclamer;
  };

  const calculateContainerHeight = (includeKeyboard = false) => {
    const hasEmailFlow =
      type === 'email' &&
      hasDisclaimer &&
      hasEmail &&
      storeInfo?.loyaltyInfo?.emailOptInDisclaimer;
    const hasPhoneFlow =
      type === 'phone' &&
      hasDisclaimer &&
      hasPhone &&
      storeInfo?.loyaltyInfo?.smsOptInDisclaimer;
    const hasZipcodeField =
      paymentType === 22 &&
      ((type === 'email' &&
        storeInfo?.loyaltyInfo?.emailOptInFields?.some(
          field => field?.toLowerCase() === 'zipcode'.toLowerCase()
        )) ||
        (type === 'phone' &&
          storeInfo?.loyaltyInfo?.smsOptInFields?.some(
            field => field?.toLowerCase() === 'zipcode'.toLowerCase()
          )));

    const heightMap = {
      text: {
        '27': {
          phone: {
            flow: { zipcode: 'h-10', default: 'h-18' },
            default: 'h-25',
          },
          email: { flow: { zipcode: 'h-8', default: 'h-15' }, default: 'h-20' },
        },
        '22': {
          phone: { flow: { zipcode: 'h-8', default: 'h-15' }, default: 'h-25' },
          email: { flow: { zipcode: 'h-6', default: 'h-12' }, default: 'h-18' },
        },
        fallback: 'h-20',
      },
      keyboard: {
        '27': {
          phone: {
            flow: { zipcode: 'h-75', default: 'h-77' },
            default: paymentCheck?.cards?.length > 0
                      ? (props.isLandScape ? 'h-80' : 'h-70')
                      : 'h-60',
          },
          email: {
            flow: { zipcode: 'h-78', default: 'h-80' },
            default: 'h-75',
          },
        },
        '22': {
          phone: {
            flow: { zipcode: 'h-87', default: 'h-80' },
            default: 'h-70',
          },
          email: {
            flow: { zipcode: 'h-89', default: 'h-82' },
            default: props.isLandScape ? 'h-80' : 'h-77',
          },
        },
        fallback: 'h-65',
      },
    };

    const config = heightMap[includeKeyboard ? 'keyboard' : 'text'];
    const screenConfig = config[screenType] || {};
    const typeConfig = screenConfig[type];

    if (!typeConfig) return config.fallback;

    if (type === 'phone' && hasPhoneFlow) {
      return hasZipcodeField
        ? typeConfig.flow.zipcode
        : typeConfig.flow.default;
    }

    if (type === 'email' && hasEmailFlow) {
      return hasZipcodeField
        ? typeConfig.flow.zipcode
        : typeConfig.flow.default;
    }

    if (includeKeyboard && screenType === '22' && type === 'phone' && !hasPhoneFlow) {
      return props.isLandScape ? 'h-80' : 'h-70';
    }

    return typeConfig.default || config.fallback;
  };

  const containerTextHeight = () => calculateContainerHeight(false);

  const containerKeyboardHeight = () => calculateContainerHeight(true);

  const memoizedZipcodeKeyboard = useMemo(() => (
    <CustomKeyboard
      setKeyboardType="number"
      onClickBtn={memoizedKeyboardOnClick}
      type="number"
      btnSize="btn35"
      customClass={cn(
        'fs-30 background-primary',
        style?.zipcodeKeyboard
      )}
      zipcodeFlag={true}
      closeKeyboard={closeKeyboard}
    />
  ), [memoizedKeyboardOnClick, closeKeyboard]);

  return (
    <>
    {/* this model in use for receipt screen */}
      <Modal
        isOpen={isOpen}
        style={{
          backgroundColor: props?.serverAppTheme?.popUp_bg,
          border: props?.serverAppTheme?.popupBorder,
          boxShadow: props?.serverAppTheme?.popUp_box_shadow,
          width: '100%',
          height: '100%',
        }}
        customClass={cn('h-100 w-100')}
        customClass2={cn(style.custWidth, 'h-98 m-0')}
        customClass3={cn(style.custHeight, 'h-52 mb-auto')}
        noBackground
      >
        <div
          className={cn(
            'col-12 pb-3 justify-content-center align-items-center position-relative text-center'
          )}
          style={{ color: props?.serverAppTheme?.primary_text }}
        >
          <div
            className={'col-12 px-0 fs_32 fw-600 pb-2'}
            style={{
              color: props?.serverAppTheme?.primary_text,
            }}
          >
            <div className={cn('col-12 fw-600 fs_18 d-flex pt-3 p-0')}>
              <div className={cn('fs_18 fw-600 p-0 text-left', props.isLandScape ? 'col-4' : 'col-6')}>
                {props.seat?.tab ? 'Tab' : 'Table'} {stationName}
              </div>
             {props.isLandScape &&  <div className={cn('fs_18 fw-600 col-4 p-0 text-center')}>
                {type === 'email'
                  ? LABEL().PAY_EMAIL_RECEIPT
                  : LABEL().PAY_TEXT_RECEIPT}
              </div>}
              <div className={cn('fs_18 fw-600 p-0 text-right', props.isLandScape ? 'col-4' : 'col-6')}>
                # {props?.seat?.number}
              </div>
            </div>
          </div>
          {!props.isLandScape && <div
            className={cn(
              'col-12 px-0 fs_32 fw-600 pb-2 d-flex align-items-center justify-content-center',
              containerTextHeight()
            )}
            style={{
              color: props?.serverAppTheme?.primary_text,
            }}
          >
            {type === 'email'
              ? LABEL().PAY_EMAIL_RECEIPT
              : LABEL().PAY_TEXT_RECEIPT}
          </div>}
          {isOpen && (
            <Formik
              enableReinitialize
              initialValues={{
                email: loyaltyData?.emailAddress,
                phone: counterPhoneNumber || paymentCheck?.loyalty?.displayAccountNumber,
                optIn:
                  type === 'phone'
                    ? !storeInfo?.loyaltyInfo?.smsOptInDefaultUnselected
                    : !storeInfo?.loyaltyInfo?.emailOptInDefaultUnselected,
              }}
              onSubmit={data => {
                let errors = {};

                if (type === 'email') {
                  errors = validateEmail(data);
                } else if (type === 'phone') {
                  errors = validatePhone(data);
                }
                if (Object.keys(errors).length > 0) {
                  return;
                }
                handleReceiptSubmit(data);
              }}
            >
              {formprops => {
                const { values } = formprops;
                valuesRef.current = values;
                return (
                  <div
                    className={cn(
                      'px-0 d-flex flex-column', props.isLandScape ? (type !== 'email' ? (hasZipcode ? 'col-12' : 'col-8 mx-auto') : 'col-8 mx-auto') : 'col-12 justify-content-start',
                      containerKeyboardHeight()
                    )}
                  >
                    <Form>
                      {type === 'email' ? (
                        <KeyboardInput
                          name="email"
                          type="textWithNumericEmail"
                          value={
                            loyaltyData?.emailAddress ||
                            (SingedInloyaltyInfo?.type === 'Email' &&
                              SingedInloyaltyInfo?.email)
                          }
                          placeholder={CUSTOM_MESSAGES().ENTER_EMAIL_ADDRESS}
                          isOpen={props.isOpen && !isLink?.isOpen}
                          customClass={cn(style.emailAdd)}
                          isDone={true}
                          isLandScape={props.isLandScape}
                          isCounter={props.isCounter}
                          parentCustomClass={cn('p-0', props.isLandScape ? style.emailAlignLand2 : style.emailAlignLand)}
                          emailIsCounter={true}
                          screenType={screenType}
                          emailFlag={true}
                          setZipcodeKeyOpen={setZipcodeKeyOpen}
                          storeInfo={storeInfo}
                          emailDomain={isOnlyPhone || isOnlyEmail}
                          zipcodeKeyOpen={zipcodeKeyOpen}
                          isDriveThru={props.isDriveThru}
                          isCallCenter={props?.isCallCenter}
                        />
                      ) : (
                        <div className={cn('position-relative', props.isLandScape && type !== 'email' && 'd-flex')}>
                            {!props.isLandScape && (
                              <>
                                <KeyboardInput
                                  name="phone"
                                  type="numericDefaultWithDone"
                                  value={
                                    counterPhoneNumber || paymentCheck?.paymentCheck?.loyalty?.displayAccountNumber
                                  }
                                  placeholder={CUSTOM_MESSAGES().ENTER_PHONE_NUMBER}
                                  isOpen={props.isOpen && !isLink?.isOpen}
                                  customClass={cn(style.textAlignInitial)}
                                  maxLength={props.countryCode === '1' ? 10 : 15}
                                  parentCustomClass={cn(
                                    'p-0',
                                    isLandScape && style.textAlignInitialLand
                                  )}
                                  isPhoneNumber
                                  countryCode={code}
                                  handleCountryCodeChange={handleCountryCodeChange}
                                  ShowLandscapeMode={props.ShowLandscapeMode}
                                  isLandScape={props.isLandScape}
                                  isCounter={props.isCounter}
                                  screenType={screenType}
                                  setZipcodeKeyOpen={setZipcodeKeyOpen}
                                  isDriveThru={props.isDriveThru}
                                  isCallCenter={props?.isCallCenter}
                                />
                              </>
                            )}
                            {props.isLandScape && <>
                              <div className={cn(isLandScape && hasZipcode ? 'col-8' : 'col-12')}>
                                <KeyboardInput
                                  name="phone"
                                  type="numericDefaultWithDone"
                                  value={
                                    loyaltyData?.phoneNumber || counterPhoneNumber
                                  }
                                  placeholder={CUSTOM_MESSAGES().ENTER_PHONE_NUMBER}
                                  isOpen={props.isOpen && !isLink?.isOpen}
                                  customClass={cn(style.textAlignInitial)}
                                  maxLength={props.countryCode === '1' ? 10 : 15}
                                  parentCustomClass={cn(
                                    'p-0',
                                    isLandScape && style.textAlignInitialLand
                                  )}
                                  isPhoneNumber
                                  countryCode={code}
                                  handleCountryCodeChange={handleCountryCodeChange}
                                  ShowLandscapeMode={props.ShowLandscapeMode}
                                  isLandScape={props.isLandScape}
                                  isCounter={props.isCounter}
                                  screenType={screenType}
                                  setZipcodeKeyOpen={setZipcodeKeyOpen}
                                  isDriveThru={props.isDriveThru}
                                  isCallCenter={props?.isCallCenter}
                                />
                              </div>
                              {(type === 'email'
                                ? paymentType === 22 &&
                                storeInfo?.loyaltyInfo?.emailOptInFields?.length >
                                0 &&
                                storeInfo?.loyaltyInfo?.emailOptInFields?.some(
                                  field =>
                                    field?.toLowerCase() === 'zipcode'.toLowerCase()
                                )
                                : paymentType === 22 &&
                                storeInfo?.loyaltyInfo?.smsOptInFields?.length > 0 &&
                                storeInfo?.loyaltyInfo?.smsOptInFields?.some(
                                  field =>
                                    field?.toLowerCase() === 'zipcode'.toLowerCase()
                                )) && (
                                  <div
                                    className={cn(
                                      'col-4 px-0 pt-0 position-relative br-5 od-container-card-border'
                                    )}
                                    // style={{ opacity: !(optInData) ? '0.5' : '' }}
                                  >
                                    <input
                                      className={cn('col-12 fs_20 fw-400 text-left', style.inputField)}
                                      style={{
                                        border: 'none',
                                        height: '56px',
                                        background: props.serverAppTheme?.inputBg,
                                        borderBottom:
                                          props.serverAppTheme?.inputBorder_Bottom,
                                        color: props.serverAppTheme?.primary_text,
                                        '--placeholder-color':
                                          props.serverAppTheme?.input_placeholder,
                                      }}
                                      value={inputValue}
                                      type="text"
                                      onChange={() => {
                                        if (optInData) setInputValue('');
                                      }}
                                      id="zipcode"
                                      onFocus={() => {
                                        if (optInData) {
                                          setZipcodeKeyOpen(true);
                                          handleBlur();
                                        }
                                      }}
                                      placeholder={LABEL().RS_ZIPCODE}
                                      readOnly
                                    />
                                  </div>
                                )}
                            </>}
                        </div>
                      )}
                      <div
                        className={cn('col-12 d-flex px-0 align-items-center')}
                      >
                        {storeInfo.loyaltyInfo.supportsOptIn &&
                          storeInfo.loyaltyInfo.optInMethods.includes(type) && (
                          <div
                            className={cn(
                              'col-12 px-0 d-flex fs_18 pt-2 pb-1', props.isLandScape && type !== 'email' ? style.checkboxPdd : '',
                            )}
                            style={{
                              width: isLandScape && '707px',
                            }}
                          >
                            <div
                              className={cn(
                                'd-flex justify-content-center align-self-start'
                              )}
                            >
                              <CheckBox
                                className={cn(style.receiptCheckbox)}
                                type="checkbox"
                                name="optIn"
                                onChange={e => {
                                  setOptInData(e.target.checked);
                                  setInputValue('');
                                }}
                                noErrorDisplay
                                getError={() => { }}
                              />
                              </div>
                              <div
                                className={cn(
                                  'px-2 d-inline flex-wrap fs_18 fw-400 mt-n1 text-left'
                                )}
                                style={{
                                  color: props?.serverAppTheme?.optTextClr,
                                }}
                              >
                                {processTruncatedDisclaimer()?.length > 0 &&
                                  processTruncatedDisclaimer()?.map(
                                    (text, index) => {
                                      const isLastItem =
                                        index ===
                                        processTruncatedDisclaimer().length - 1;
                                      const hasTruncation =
                                        (screenType === '22' ||
                                          screenType === '27') &&
                                        disclamer?.length > 0 &&
                                        disclamer.join(' ').length > 80;
                                      const needsEllipsis =
                                        hasTruncation && isLastItem;
                                      const isClickableLink = text.startsWith(
                                        '#?'
                                      );
                                      const displayText = isClickableLink
                                        ? text.replace('#?', '')
                                        : text;

                                      return isClickableLink ? (
                                        <span key={index}>
                                          &nbsp;
                                          <span
                                            role="presentation"
                                            onClick={() =>
                                              handleLink(displayText)
                                            }
                                            className={cn(
                                              'text-underline',
                                              style.link
                                            )}
                                            style={{
                                              color:
                                                props?.serverAppTheme
                                                  ?.link_color,
                                            }}
                                          >
                                            {displayText}
                                            {needsEllipsis ? '...' : ''}
                                          </span>
                                          &nbsp;
                                        </span>
                                      ) : (
                                        <span key={index}>
                                          {displayText}
                                          {needsEllipsis ? '...' : ''}
                                        </span>
                                      );
                                    }
                                  )}
                              </div>
                            </div>
                          )}
                        {(props.isCounter || props?.isDriveThru || props?.isCallCenter) && disclamer?.length > 0 && (
                          <div className="col-3"></div>
                        )}
                      </div>
                      {!props.isLandScape && (
                        <>
                          {(type === 'email'
                            ? paymentType === 22 &&
                            storeInfo?.loyaltyInfo?.emailOptInFields?.length >
                            0 &&
                            storeInfo?.loyaltyInfo?.emailOptInFields?.some(
                              field =>
                                field?.toLowerCase() === 'zipcode'.toLowerCase()
                            )
                            : paymentType === 22 &&
                            storeInfo?.loyaltyInfo?.smsOptInFields?.length > 0 &&
                            storeInfo?.loyaltyInfo?.smsOptInFields?.some(
                              field =>
                                field?.toLowerCase() === 'zipcode'.toLowerCase()
                            )) && (
                              <div
                                className={cn(
                                  'col-12 px-0 pt-2 position-relative br-5 od-container-card-border'
                                )}
                                style={{ opacity: !(optInData) ? '0.5' : '' }}
                              >
                                <input
                                  className={cn('col-12 fs_20 fw-400 text-left', style.inputField)}
                                  style={{
                                    border: 'none',
                                    height: '50px',
                                    background: props.serverAppTheme?.inputBg,
                                    borderBottom:
                                      props.serverAppTheme?.inputBorder_Bottom,
                                    color: props.serverAppTheme?.primary_text,
                                    '--placeholder-color':
                                      props.serverAppTheme?.input_placeholder,
                                  }}
                                  value={inputValue}
                                  type="text"
                                  onChange={() => {
                                    if (optInData) setInputValue('');
                                  }}
                                  id="zipcode"
                                  onFocus={() => {
                                    if (optInData) {
                                      setZipcodeKeyOpen(true);
                                      handleBlur();
                                    }
                                  }}
                                  placeholder={LABEL().RS_ZIPCODE}
                                  readOnly
                                />
                              </div>
                            )}
                        </>
                      )}
                      {paymentType === 22 && zipcodeKeyOpen && optInData && (
                        <div
                          className={cn(
                            'position-absolute p-2',
                            `${keyboardBottomClass}`
                          )}
                          style={{
                            background: props.serverAppTheme?.keyBoard_Bg_Color,
                            width: props.isLandScape ? '100%' : '30.375rem',
                            bottom: type === 'email' ? '8.5rem' : props.isLandScape ? '3rem' : '9.5rem',
                            zIndex: 998,
                          }}
                        >
                          {memoizedZipcodeKeyboard}
                        </div>
                      )}
                      <div
                        className={cn(
                          'px-0 d-flex justify-content-center align-items-center text-center',
                          (storeInfo.loyaltyInfo.smsOptInDisclaimer ||
                            storeInfo.loyaltyInfo.emailOptInDisclaimer) !== null
                            ? 'mt-1'
                            : '',
                          (props.isCounter || props?.isDriveThru || props?.isCallCenter) ? style.continueLand : '',
                          props.isLandScape && hasZipcode ? type !== 'email' ? `${style.btnMarginZopcode} col-8` : 'col-12' : 'col-12',
                        )}
                        style={{
                          position: 'absolute',
                          bottom: zipcodeKeyOpen ? (props.isLandScape ? '-15px' : '2px') : props.isLandScape ? (type !== 'email' ? (hasZipcode ? '-20px' : '-50px') : (hasDisclaimer ? '-50px' : (paymentType === 27 ? '-75px' : '-50px'))) : '7px',
                        }}
                      >
                        <div className="col-6 pl-0 pr-1">
                          <TouchableButton
                            className={cn('px-0 fs_28 w-100 btn-ripple btnBorder od-cancel-btn-bg-color  od-cancel-btn-font-color od-cancel-btn-st-color', props.isLandScape ? 'btn44' : 'btn68')}
                            style={{
                              color: props.serverAppTheme?.cancleBtn_font,
                              backgroundColor:
                                props.serverAppTheme?.OFF_Premise_Btn,
                              border: props.serverAppTheme?.cancleBtn_Border,
                            }}
                            onClick={e => {
                              e.preventDefault();
                              handleCloseReceipt();
                            }}
                            rippleEffect={true}
                          >
                            <div
                              className={cn('fw-600 fs_28')}
                              style={{
                                fontSize: isServerApp
                                  ? (props.isCounter || props.isDriveThru || props?.isCallCenter)
                                    ? '24px'
                                    : ''
                                  : '',
                              }}
                            >
                              {LABEL().CS_CANCEL}
                            </div>
                          </TouchableButton>
                        </div>
                        <div className="px-0 pl-1 col-6">
                          <TouchableButton
                            className={cn(
                              'col-12 px-0 btn-ripple fs-30  od-primary-btn-bg-color od-primary-btn-font-color', props.isLandScape ? 'btn44' : 'btn68'
                            )}
                            type="submit"
                            style={{
                              backgroundColor:
                                props?.serverAppTheme?.secondaryBtn,
                              color: 'white',
                            }}
                            rippleEffect={true}
                          >
                            <div
                              className={cn('fw-600 fs_28')}
                              style={{
                                fontSize: isServerApp
                                  ? (props.isCounter || props?.isDriveThru || props?.isCallCenter)
                                    ? '24px'
                                    : ''
                                  : '',
                              }}
                            >
                              {LABEL().CONTINUE}
                            </div>
                          </TouchableButton>
                        </div>
                      </div>
                    </Form>
                  </div>
                );
              }}
            </Formik>
          )}
        </div>
      </Modal>

      <Modal isOpen={isLink?.isOpen}>
        <div className="col-12 px-1 text-right">
          <i
            role="presentation"
            onClick={() => setIsLink({ isOpen: false, link: '' })}
          />
        </div>
        {loader && <Loader />}
        {isLink?.isOpen && (
          <iframe
            title="iframe"
            src={isLink?.link || ''}
            scrolling="auto"
            toolbar="0"
            ref={iframeRef}
            style={{
              width: '100%',
              height: 'calc(84vh)',
              border: '0',
            }}
            onLoad={() => {
              clearTimeout(timeoutId.current);
              setLoader(false);
            }}
            onError={e => {
              clearTimeout(timeoutId.current);
              setLoader(false);
            }}
            referrerPolicy="strict-origin-when-cross-origin"
          />
        )}
      </Modal>
    </>
  );
};

const mapSateToProps = ({ theme, keyboard, orders }) => ({
  serverAppTheme: theme.serverAppTheme,
  isKeyboardOpen: keyboard.isKeyboardOpen,
  seat: orders.seats,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      keyboardCloseForDone,
      setErrorPopUp,
      keyboardOpen,
      keyboardOpenForClickText,
      handleLoyaltyInfo
    },
    dispatch
  );

export default connect(mapSateToProps, mapDispatchToProps)(ReceiptScreenPopUp);
